/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

import s from "./ImageViewer.module.css";

import { getEnvs } from "state/EnvironmentsContext/EnvContext";
import Loading from "../Loading";
import Image from "../Image/Image";

export interface ImageViewerInterface {
  src?: string;
  alt?: string;
  className?: string;
  variant?: "circle";
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "full";
  fit?: "cover" | "contain" | "fill";
  isLoading?: boolean;
  hasBorder?: boolean;
  hasBg?: boolean;
  multiple?: boolean;
  placeholderSize?: "sm" | "md" | "lg";
}

const ImageViewer = ({
  variant,
  src,
  placeholderSize,
  alt,
  className,
  size,
  hasBorder,
  isLoading = false,
  fit = "cover",
  hasBg = false,
  ...rest
}: ImageViewerInterface) => {
  // let placeHolder;
  const { placeholder, placeholder_small, placeholder_large } = getEnvs(
    (state) => state,
  );

  let DEFAULT_PLACEHOLDER = placeholder;

  if (variant === "circle" || src === undefined || src === "" || src === null) {
    DEFAULT_PLACEHOLDER = placeholder;
  }

  let fitClass = "object-cover";
  if (fit === "contain") {
    fitClass = "object-contain";
  }

  if (fit === "fill") {
    fitClass = "object-fill";
  }

  switch (placeholderSize) {
    case "sm":
      DEFAULT_PLACEHOLDER = placeholder_small;
      break;
    case "md":
      DEFAULT_PLACEHOLDER = placeholder;
      break;
    case "lg":
      DEFAULT_PLACEHOLDER = placeholder_large;
      break;
  }

  return (
    <div
      className={cn(
        s.root,
        "relative",
        className,
        size && s[size],
        variant && s[variant],
        hasBorder && s.hasBorder,
      )}
      test-id="9dBFFHvA"
    >
      {isLoading ? (
        <Loading className="w-3/4 m-auto" bgColor="" test-id="hoftk44R" />
      ) : (
        <>
          <Image
            src={src || DEFAULT_PLACEHOLDER}
            alt={alt || "image"}
            {...rest}
            className={cn(className, fitClass, hasBg && "bg-secondary-accent")}
            test-id="T4x-9noG"
          />
        </>
      )}
    </div>
  );
};

export default ImageViewer;
